import { Card, Icon, Typography } from 'components';
import { CardErrorBoundaryWithSpinfinity } from 'components/Card/CardErrorBoundaryWithSpinfinity';
import MaturationIndexGraph from 'components/MaturationIndexGraph/MaturationIndexGraph';
import { stringifyDaysOld } from 'helpers';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import useSubMetricEvaluations from 'services/insights/useSubMetricEvaluations';
import { InsightMetric } from 'types/Insights';

import styles from './MatIndexCard.module.css';

export const MATURATION_INDEX_CATEGORY_KEY = 'Maturation';

interface MatIndexCardContentProps {
  maturationIndexSubMetric: InsightMetric | undefined;
}

const MatIndexCardContent = ({ maturationIndexSubMetric }: MatIndexCardContentProps) => {
  const { currentKit, currentTinyAccount } =
    useCurrentKitAndTinyAccount();

  if (!currentKit || !maturationIndexSubMetric) return <></>;
  
  return (
    <>
      <div className={styles.titleContainer}>
        <Typography variant='heading-s' className={styles.textLink}>
          {`${currentTinyAccount?.first_name}'s gut trajectory`}
        </Typography>
        <Icon name='chevronForward' size='s' className={styles.titleIcon} />
      </div>
      <div className='flex flex-column'>
        <Typography
          variant={'heading-m'}
        >{`Gut Age: ${stringifyDaysOld(maturationIndexSubMetric.user_value)}`}</Typography>
        <MaturationIndexGraph
          kit={currentKit}
          subMetric={maturationIndexSubMetric}
          minHeight={100}
          hideAllAxisLabels
          onlyCurrentKit
        />
      </div>
    </>
  );
};

export const MatIndexCard = () => {
  const { currentKitId } = useCurrentKitAndTinyAccount();
  const { data: metrics } = useSubMetricEvaluations();
  
  const maturationIndexSubMetric = metrics.find(
    subMetric => subMetric.category_key === MATURATION_INDEX_CATEGORY_KEY,
  );
  
  return (
    <CardErrorBoundaryWithSpinfinity cardName="MatIndexCard">
      <Card
        clickable={
          maturationIndexSubMetric
            ? {
                href: `/results/${currentKitId}/metrics/all-metrics/${maturationIndexSubMetric.gut_vaginal_health?.id}`,
                text: "Gut trajectory",
                isExternal: false,
              }
            : undefined
        }
      >
        <MatIndexCardContent maturationIndexSubMetric={maturationIndexSubMetric} />
      </Card>
    </CardErrorBoundaryWithSpinfinity>
  );
};
